import dayjs, { Dayjs } from "dayjs";
import { OptionTime } from "./types";

export const defaultTime = {
	endTime: "24:00",
	startTimeValue: "18:00:00",
	endTimeValue: "09:00:00",
	replaceEndTimeValue: "24:00:00"
};

const startTimeOption = dayjs().set("hour", 0).set("minute", 0).set("second", 0);
const defaultTimeType = "HH:mm";

/**
 * @description
 * Do Not Disturb Time Settings > Time Selection
 * : Selectable in 30-minute increments (Default: 18:00 - 09:00)
 * -Start Time: 00:00 ~ 23:30
 * -End Time: Specify in 30-minute increments
 **/
export const calculateTimeOption = (
	startTime: Dayjs = startTimeOption,
	isEndTimeOptions: boolean = false
): OptionTime[] => {
	const timeOptions: OptionTime[] = [];
	let currentTime = isEndTimeOptions ? startTime.add(30, "minute") : startTime;

	const maxEndTime = startTime.add(24, "hour");

	while (currentTime.isBefore(maxEndTime) || currentTime.format("HH:mm") === maxEndTime.format("HH:mm")) {
		const timeObject = {
			label: currentTime.format(defaultTimeType),
			value: `${currentTime.format(defaultTimeType)}:00`
		};
		timeOptions.push(timeObject);
		currentTime = currentTime.add(30, "minute");
	}

	return timeOptions;
};

export function convertTime(time: string): Dayjs {
	const timeArray = time.split(":");
	return dayjs().set("hour", Number(timeArray[0])).set("minute", Number(timeArray[1]));
}
